if (!window.CapsuleCardRelatedProducts) {
    window.CapsuleCardRelatedProducts = class extends HTMLElement {
        constructor() {
            super();

            this.initialized = false;
            this.flkty = null;
        }

        connectedCallback() {
            if (this.initialized) return;

            const Flickity = window.theme && window.theme.Flickity;
            if (!Flickity) {
                return;
            }

            const items = this.querySelectorAll('[data-capsule-related-item]');
            console.log(items);
            if (!items.length) return;

            this.initialized = true;

            this.flkty = new Flickity(this, {
                cellSelector: '[data-capsule-related-item]',
                cellAlign: 'center',
                contain: true,
                prevNextButtons: true,
                draggable: true,
                pageDots: false,
                wrapAround: true,
                adaptiveHeight: false,
            });
        }
    };
}

if (!customElements.get('capsule-card-related-products')) {
    customElements.define('capsule-card-related-products', window.CapsuleCardRelatedProducts);
}
